import { ColumnProvider } from '../interfaces/ColumnProvider';
import { DateRange } from 'owa-datetime-utils';
import { getDate } from './DateOffsetConversion';
import { LayoutInterval } from '../interfaces/LayoutInterval';
import { VisibleTime } from 'owa-calendar-surface-core';

/**
 * Converts the given layout interval into a date range.
 * @param interval The interval to be converted to a date range.
 * @param store Settings from the calendar surface store
 * @param columnProvider A column provider to convert a column indexes to date.
 */
export function getDateRange(
    interval: LayoutInterval,
    store: VisibleTime,
    columnProvider: ColumnProvider
): DateRange {
    const start = getDate(interval.start, store, columnProvider);
    const end = getDate(interval.end, store, columnProvider, true);

    return { start, end };
}
